<button mat-icon-button color="primary" (click)="ouvrirGraph()" matTooltip="Visualiser les statistiques de favoris et d'abonnement">
  <mat-icon>equalizer</mat-icon>
</button>